import { CustomMeasureProvider, defToMeasure } from 'services/model/customMeasures';
import { InterpretationValue } from 'models/measureInterpretation';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { useIntl } from 'react-intl';

export const usePromotionMeasures = () => {
  const intl = useIntl();
  return {
    oldPrice: defToMeasure(
      {
        code: 'oldPrice',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.promotion.table.before.promotion',
      },
      intl
    ),
    promoPrice: defToMeasure(
      {
        code: 'promoPrice',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.promotion.table.during.promotion',
      },
      intl
    ),
    newPrice: defToMeasure(
      {
        code: 'newPrice',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.CURRENCY,
        translationId: 'trading.promotion.table.after.promotion',
      },
      intl
    ),
    oldDailyQty: defToMeasure(
      {
        code: 'oldDailyQty',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.QUANTITY,
        translationId: 'trading.promotion.table.before.promotion',
      },
      intl
    ),
    dailyQty: defToMeasure(
      {
        code: 'dailyQty',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.QUANTITY,
        translationId: 'trading.promotion.table.after.promotion',
      },
      intl
    ),
    dailyQtyDelta: defToMeasure(
      {
        code: 'dailyQtyDelta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.daily_items_delta_percent',
      },
      intl
    ),
    dailyGmvDelta: defToMeasure(
      {
        code: 'dailyGmvDelta',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.PERCENT,
        translationId: 'trading.price_change.table.daily_gmv_delta_percent',
      },
      intl
    ),
  } as CustomMeasureProvider;
};
